import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { links } from '@/common/utils/links';
import { RootLayout } from '@/layouts/Root';

const BatchInvoicing = lazy(
  () => import('@/modules/invoicing/pages/BatchInvoicing'),
);
const Invoice = lazy(() => import('@/modules/invoicing/pages/Invoicing'));
const OpenInvoicing = lazy(
  () => import('@/modules/invoicing/pages/OpenInvoicing'),
);
const BatchCompliance = lazy(
  () => import('@/modules/invoicing/pages/BatchCompliance'),
);

export const InvoicingRoutes: RouteObject[] = [
  {
    element: <RootLayout />,
    children: [
      {
        path: links.invoicing.invoicing,
        element: <Invoice />,
      },
      {
        path: links.invoicing.openInvoices,
        element: <OpenInvoicing />,
      },
      {
        path: links.invoicing.batchInvoices(),
        element: <BatchInvoicing />,
      },
      {
        path: links.invoicing.batchCompliance(),
        element: <BatchCompliance />,
      },
    ],
  },
];
